mutation DisableClickToCallIntegration {
    disableClickToCallIntegration {
        clickToCallIntegration {
            integrationType
            isEnabled
            phoneNumber
            callerId
            defaultCallsActivityType {
                id
                name
                icon
                isImmutable
            }
            defaultVoicemailsActivityType {
                id
                name
                icon
                isImmutable
            }
        }
    }
}
